import type { Epic } from 'Flux/index.js'
import { orderSlice } from 'Flux/Slice/Order/OrderSlice.js'
import { authenticationExpiredOr } from 'Framework/Epic/AuthenticationExpired.js'
import { catchError, filter, mergeMap, of } from 'rxjs'

export const requestFileUploadEpic: Epic = (action$, state$, { [orderSlice.name]: order, OrderRepository }) =>
  action$.pipe(
    filter(order.requestFileUploadURL.match),
    mergeMap((action) =>
      OrderRepository.requestFileUploadUrl(action.payload.orderId, action.payload.poolId, { files: action.payload.files }).pipe(
        mergeMap((response) => {
          console.log(response)
          return of(order.requestFileUploadURLSuccess(response))
        }),
        catchError((error) =>
          authenticationExpiredOr({
            error,
            failedRequest: action.type,
            failureAction: of(order.requestFileUploadURLFailure({ error }))
          })
        )
      )
    )
  )
